import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function AlineAIIcon({
  className,
  fill = 'none',
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill={fill}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M18.5703 6C18.5619 8.20777 19.6386 9.46721 22.0844 9.51406C19.8138 9.50563 18.6856 10.7238 18.5703 13.0281C18.5506 10.8541 17.577 9.51406 15.0563 9.51406C17.3118 9.48314 18.5619 8.39425 18.5703 6Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M6.95061 8.04753C6.93843 11.1568 8.44994 12.9204 11.9003 12.9981C8.70015 12.986 7.11273 14.7018 6.95061 17.9478C6.91969 14.8854 5.55061 12.9935 2 12.9981C5.17671 12.9532 6.93843 11.4201 6.95061 8.04753Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
